module.exports = __webpack_public_path__ + "img/single-post-img3-400x263.fd1bc892.jpg";